<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			停靠点管理
		</div>
		<div class="page_top_box">
			<div class="top_input_box">
				<el-input placeholder="请输入停靠点名称" v-model="name" clearable>
				</el-input>
			</div>
			<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
			<el-button type="primary" icon="el-icon-circle-plus-outline"
				style="background-color: #F65600;border: none;margin-left: auto;" @click="show">
				添加停靠点</el-button>
		</div>
		<div class="table_box">
			<el-table :data="tableData" style="width: 100%;">
				<el-table-column prop="name" label="停靠点名称" align='center'>
				</el-table-column>
				<el-table-column prop="longitude" label="停靠点经度" align='center'>
				</el-table-column>
				<el-table-column prop="latitude" label="停靠点纬度" align='center'>
				</el-table-column>
				<el-table-column prop="azimuth" label="停靠点航向" align='center'>
				</el-table-column>
				<el-table-column prop="remark" label="描述" align='center'>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" align='center'>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align='center'>
					<template slot-scope="scope">
						<el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
						<el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="table_paging">
				<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
					:total="currentTotal" background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<div class="model" v-if="modelShow">
			<div class="mask"></div>
			<div class="model-dialog" v-loading="loading" element-loading-text="请求中..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
					<div class="model-header">
						<span>{{title}}</span>
						<i class="el-icon-close" @click="hide"></i>
					</div>
					<div class="model-body">
						<el-form ref="form" :model="form" label-width="80px">
							<el-form-item label="停靠点名称" label-width='100px'>
								<el-input v-model="form.name"></el-input>
							</el-form-item>
							<el-form-item label="停靠点经度" label-width='100px'>
								<el-input v-model="form.longitude"></el-input>
							</el-form-item>
							<el-form-item label="停靠点纬度" label-width='100px'>
								<el-input v-model="form.latitude"></el-input>
							</el-form-item>
							<el-form-item label="停靠点航向" label-width='100px'>
								<el-input v-model="form.azimuth"></el-input>
							</el-form-item>
							<el-form-item label="描述" label-width='100px'>
								<el-input type="textarea" v-model="form.remark"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<div class="model-footer">
						<div class="left-btn" @click="onSubmit">确认</div>
						<div class="right-btn" @click="hide">取消</div>
					</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				name: '', //搜索停靠点名称
				modelShow: false, //添加编辑弹框控制
				title: '', //添加编辑弹框顶部文字
				form: {
					name: '', //停靠点名称
					longitude: '', //停靠点经度
					latitude: '', //停靠点纬度
					azimuth: '', //停靠点航向
					remark: '', //备注
				},
				tableData: [], //数据
				currentPage: 1, //页数
				pageSize: 10, //每页数量
				currentTotal: 0, //总数
				loading: false, //加载Loading
			}
		},
		mounted() {
			this.getData()
		},
		methods: {
			async getData() {
				let result = await this.request.post("/v1.0/parkPoint/getPageData", {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					name: this.name == '' ? null : this.name,
				});
				console.log(result.data)
				this.tableData = result.data.dataList
				this.currentTotal = result.data.totalCount - 0
			},
			// 搜索按钮
			search() {
				this.currentPage = 1
				this.pageSize = 10
				this.getData()
			},
			show() {
				this.judge = 1
				this.title = '添加停靠点'
				this.form = {}
				this.modelShow = true
			},
			hide() {
				this.modelShow = false
			},
			editClick(e) {
				console.log(e)
				this.judge = 2
				this.title = '编辑停靠点'
				this.form.id = e.id
				this.request.post("/v1.0/parkPoint/getDetail", {
					id: e.id,
				}).then((result) => {
					if (result.code == 0) {
						this.form.name = result.data.name
						this.form.longitude = result.data.longitude
						this.form.latitude = result.data.latitude
						this.form.azimuth = result.data.azimuth
						this.form.remark = result.data.remark
					}
				})
				this.modelShow = true
			},
			// 弹框确认按钮
			async onSubmit() {
				var that = this
				this.loading = true
				if (that.judge == 1) {
					let result = await that.request.post("/v1.0/parkPoint/create", that.form);
					if (result.code == 0) {
						that.$message({
							type: 'success',
							message: '添加成功!'
						});
						that.modelShow = false
						that.search()
						that.loading = false
					} else {
						that.loading = false
					}
				} else {
					let result = await that.request.post("/v1.0/parkPoint/update", that.form);
					if (result.code == 0) {
						that.$message({
							type: 'success',
							message: '修改成功!'
						});
						that.modelShow = false
						that.search()
						that.loading = false
					} else {
						that.loading = false
					}
				}
			},
			deleteClick(e) {
				console.log(e)
				this.$confirm('是否删除此条数据', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.request.post("/v1.0/parkPoint/delete", {
						id: e.id
					}).then((result) => {
						console.log(result)
						if (result.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.search()
						}
					})
				}).catch(() => {
					// this.$message({
					//   type: 'info',
					//   message: '已取消删除'
					// });          
				});
			},
			handleCurrentChange(val) {
				console.log(val)
				this.currentPage = val
				//点击下一页的时候 重新调用接口从后端取分页数据;{ current: this.currentPage } 为传给后端的字段
				this.getData()
			},
		}
	}
</script>

<style>
</style>
